import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD
} from "../../../../../constants";
import { moveItemToBag, addItemToBag } from "../../../../../services/bag";

const operationMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: moveItemToBag,
  [ITEMS_TYPE_SHARED_BOARD]: addItemToBag
};

export const getToBagOperation = ({ common: { itemsType } }) =>
  operationMap[itemsType];
